import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstMiddleAndLastName'
})
export class FirstMiddleAndLastName implements PipeTransform {
    transform(fullName: string): any {
        //if name doesn't contains @, get first and last name
        if (fullName && !fullName.includes('@')) {
            const str = fullName.split(' ');
            return str.length >= 4 ? str[0] + ' ' + str[1] + ' ' + str[str.length - 1] : fullName;
        } else {
            return fullName;
        }
    }
}
